import { useState } from "react";
import { MobileModal } from "../MobileModal/MobileModal";

import { GlobalSearch } from "./GlobalSearch";
import './GlobalSearchBar.scss';
export const GlobalSearchButton = ({ children, ...props}) => {
    const [open, setOpen] = useState(false);
    const onClick = () => setOpen(prev => !prev);
    return (
        <>
            <span className="global-search-btn-component" onClick={onClick}>
                {children}
            </span>
            <MobileModal open={open}>
                <GlobalSearch {...props}/>
            </MobileModal>
        </>

    )
}